// extracted by mini-css-extract-plugin
module.exports = {"input":"Counter_input__r1_g5"};